// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","copyright":"footer_copyright__34ZuF","terms":"footer_terms__N9Ndz"};